(function () {
  var sectionSelector = '.avanelle-new-faq';

  function initSection(section) {
    if (!section || section.dataset.anfaqReady === 'true') {
      return;
    }

    var items = Array.from(section.querySelectorAll('.avanelle-new-faq__item'));
    if (!items.length) {
      section.dataset.anfaqReady = 'true';
      return;
    }

    var cleanupFns = [];

    function openItem(item) {
      var trigger = item.querySelector('[data-anfaq-trigger]');
      var panel = item.querySelector('[data-anfaq-panel]');
      if (!trigger || !panel) {
        return;
      }

      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }

    function closeItem(item) {
      var trigger = item.querySelector('[data-anfaq-trigger]');
      var panel = item.querySelector('[data-anfaq-panel]');
      if (!trigger || !panel) {
        return;
      }

      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      panel.style.maxHeight = '0px';
    }

    function onResize() {
      items.forEach(function (item) {
        if (item.classList.contains('is-open')) {
          var panel = item.querySelector('[data-anfaq-panel]');
          if (panel) {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }
        }
      });
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-anfaq-trigger]');
      var panel = item.querySelector('[data-anfaq-panel]');
      if (!trigger || !panel) {
        return;
      }

      panel.style.maxHeight = '0px';

      var onClick = function () {
        if (item.classList.contains('is-open')) {
          closeItem(item);
        } else {
          openItem(item);
        }
      };

      trigger.addEventListener('click', onClick);
      cleanupFns.push(function () {
        trigger.removeEventListener('click', onClick);
      });
    });

    window.addEventListener('resize', onResize);
    cleanupFns.push(function () {
      window.removeEventListener('resize', onResize);
    });

    section._anfaqCleanup = function () {
      cleanupFns.forEach(function (fn) {
        fn();
      });
    };

    section.dataset.anfaqReady = 'true';
  }

  function cleanupSection(section) {
    if (section && typeof section._anfaqCleanup === 'function') {
      section._anfaqCleanup();
      delete section._anfaqCleanup;
      delete section.dataset.anfaqReady;
    }
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll(sectionSelector);

    if (!sections.length && scope.matches && scope.matches(sectionSelector)) {
      initSection(scope);
      return;
    }

    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var target = event.target;
    if (target && target.matches && target.matches(sectionSelector)) {
      cleanupSection(target);
      return;
    }
    if (target && target.querySelectorAll) {
      target.querySelectorAll(sectionSelector).forEach(cleanupSection);
    }
  });
})();
